import { render, staticRenderFns } from "./InboxView.vue?vue&type=template&id=5f760492"
import script from "./InboxView.vue?vue&type=script&lang=js"
export * from "./InboxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports